import { generatePath } from "~/utils/generatePath";

const paths = {
	floorMap: `${process.env.NEXT_PUBLIC_API_HOST}/api/vendors/deals/:id/floor_map`,
	leaseContractFile: `${process.env.NEXT_PUBLIC_API_HOST}/api/vendors/deals/:id/lease_contract_file?file_number=:file_number`
};

export const getFloorMapPath = (dealId: number): string =>
	paths.floorMap.replace(":id", String(dealId));

export const getLeaseContractFilePath = (
	dealId: number,
	fileNumber: number
): string =>
	paths.leaseContractFile
		.replace(":id", String(dealId))
		.replace(":file_number", String(fileNumber));

export const getInspectionFilePath = (dealId: number): string =>
	new URL(
		generatePath("/api/vendors/deals/:deal_id/leasing_inspection_file", {
			deal_id: dealId
		}),
		process.env.NEXT_PUBLIC_API_HOST
	).toString();
